import { get } from 'lodash'
import {
  ORDER_STATE_ENUM,
  ORDER_REFUND_STATE_ENUM,
  E_SKUTAG,
  ORDER_MONEY_PAY_TYPE,
  OrderDetailActionType_ENUM,
  AllActionObjsInOrderDetail,
  E_PROMOTION_TYPE,
  SELF_PHOTO_TYPE_ENUM,
  SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM,
  ORDER_TYPE_FOR_PERIOD
} from '@/config'
import { getOrderMoneyPayType } from '@/utils'
import { isUnionYueSao } from '@/business/order'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export function getButtonListNormal(order, groupDetail) {
  /**
     * "orderState": 10, //10.待支付20.待使用30.待评价40.已完成50.已取消  70.已过期
     * "refundState": 10, //10.未申请退款20.已申请退款30.退款完成40退款失败(可选项)
     * "barcodeList"[0]."workState":30, 
     * //仅限签约月嫂 上户状态 0:待申请上户 30:已申请上户 35:驳回上户 40:已确认上户
     * 
     * 
     * channelType //1.正常下单2.一元购3.抢购4.团购5.积分
        smallGroupStatus //小团状态(1-参团中 2团成功 3 团失败 )
     */

  let {
    orderState,
    refundState,
    channelType,
    selfPhotoType,
    supportReserve,
    payPeriodType,
    reserveRecord,
    level4CategoryId,
    giveInsure
  } = order
  let moneyPayType = getOrderMoneyPayType(order)

  orderState = orderState && +orderState
  refundState = refundState && +refundState
  // //TODO test
  // orderState = 70
  // refundState = 30

  let currStateActionBtns = []

  if (ORDER_REFUND_STATE_ENUM.SUCCESSED == refundState) {
    // 退款成功 btn：删除订单  （只有退款成功、已取消，才会有'删除订单'）
    currStateActionBtns.push(
      AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_DEL_ORDER)
    )
    // 可能评价过后退款成功的
    order.commentId &&
      currStateActionBtns.push(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_LOOK_COMMENTS
        )
      )
    return currStateActionBtns
  }

  if (ORDER_STATE_ENUM.PENDING_PAY == orderState) {
    // 待支付 btn：立即支付/支付定金/支付尾款、取消订单

    if (ORDER_MONEY_PAY_TYPE.prePayOrder == moneyPayType) {
      if (ORDER_REFUND_STATE_ENUM.APPLIED != refundState) {
        currStateActionBtns.push(
          AllActionObjsInOrderDetail.get(
            OrderDetailActionType_ENUM.TO_CANCEL_ORDER
          )
        )
        currStateActionBtns.push(
          AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_PAY_PRE)
        )
      }
    } else if (ORDER_MONEY_PAY_TYPE.endPayOrder == moneyPayType) {
      // 待支付尾款 btn：申请退款(定金)
      // 拼团商品不支持退款 smallGroupStatus:小团状态(1-参团中 2团成功 3 团失败 )
      if (
        ORDER_REFUND_STATE_ENUM.APPLIED != refundState &&
        canRefund(order) &&
        (order.channelType != 4 ||
          (groupDetail && groupDetail.smallGroupStatus > 1))
      ) {
        currStateActionBtns.push(
          AllActionObjsInOrderDetail.get(
            OrderDetailActionType_ENUM.TO_APPLY_REFUND
          )
        )
      }
      currStateActionBtns.push(
        AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_PAY_REST)
      )
    } else {
      if (ORDER_REFUND_STATE_ENUM.APPLIED != refundState) {
        currStateActionBtns.push(
          AllActionObjsInOrderDetail.get(
            OrderDetailActionType_ENUM.TO_CANCEL_ORDER
          )
        )
        currStateActionBtns.push(
          AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_PAY)
        )
      }
    }
  } else if (ORDER_STATE_ENUM.CANCELED == orderState) {
    // 已取消 btn：删除订单
    currStateActionBtns.push(
      AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_DEL_ORDER)
    )
  } else if (ORDER_STATE_ENUM.TO_BE_USED == orderState) {
    // 待核销 btn：申请退款
    // 拼团商品不支持退款 smallGroupStatus:小团状态(1-参团中 2团成功 3 团失败 )
    if (
      ORDER_REFUND_STATE_ENUM.APPLIED != refundState &&
      canRefund(order) &&
      (order.channelType != 4 ||
        (groupDetail && groupDetail.smallGroupStatus > 1))
    ) {
      currStateActionBtns.push(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_APPLY_REFUND
        )
      )
    }

    // btn：确认完成/确认收货
    if (
      ORDER_REFUND_STATE_ENUM.NOT_APPLIED == refundState ||
      ORDER_REFUND_STATE_ENUM.FAILED == refundState
    ) {
      // 不是拼团，或者是拼团已成功，才显示确认完成/收货
      if (
        channelType != 4 ||
        (channelType == 4 && groupDetail && groupDetail.smallGroupStatus == 2)
      ) {
        if (
          E_SKUTAG.POPYUSAO == order.skuTag ||
          E_SKUTAG.APPLIANCE_WASHING == order.skuTag
        ) {
          currStateActionBtns.push(
            AllActionObjsInOrderDetail.get(
              OrderDetailActionType_ENUM.TO_CONFIRM_COMPLETED
            )
          )
        } else if (E_SKUTAG.POPENTITY == order.skuTag) {
          currStateActionBtns.push(
            AllActionObjsInOrderDetail.get(
              OrderDetailActionType_ENUM.TO_CONFIRM_RECEIVED
            )
          )
        } else if (E_SKUTAG.UNIONHOME == order.skuTag) {
          currStateActionBtns.push(
            AllActionObjsInOrderDetail.get(
              OrderDetailActionType_ENUM.TO_CONFIRM_COMPLETED
            )
          )
        }
      }
    }
  } else if (ORDER_STATE_ENUM.WAITING_4_EVALUATE == orderState) {
    // 待评价 btn：立即评价 、申请售后
    currStateActionBtns.push(
      AllActionObjsInOrderDetail.get(
        OrderDetailActionType_ENUM.TO_SERVICE_TEL_NORMAL
      )
    )
    currStateActionBtns.push(
      AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_COMMENT)
    )
  } else if (ORDER_STATE_ENUM.FINISHED == orderState) {
    // 已完成 btn: 查看评价 、申请售后
    //order.commentId &&
    currStateActionBtns.push(
      AllActionObjsInOrderDetail.get(
        OrderDetailActionType_ENUM.TO_SERVICE_TEL_NORMAL
      )
    )
    order.commentId &&
      currStateActionBtns.push(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_LOOK_COMMENTS
        )
      )
  }

  // "预约拍摄"，“修改预约”--自营摄影普通
  if (
    SELF_PHOTO_TYPE_ENUM.NORMAL == selfPhotoType &&
    SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM.YES == supportReserve &&
    ORDER_STATE_ENUM.TO_BE_USED == orderState
  ) {
    if (!reserveRecord) {
      currStateActionBtns.push(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO
        )
      )
    }
    // else {
    //     currStateActionBtns.push(AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO))
    // }
  }

  if (giveInsure) {
    currStateActionBtns.unshift(
      AllActionObjsInOrderDetail.get(
        OrderDetailActionType_ENUM.TO_SEE_INSURANCE
      )
    )
  }

  return currStateActionBtns
}

function canRefund(order) {
  // 所有码都未使用才可以申请退单，0元订单不支持申请退单  商品必须是随时退才露出申请退款
  const codes = order.barcodeList || []
  let canUseCodes = codes
  if (codes && codes.length > 0) {
    canUseCodes = codes.filter(v => v.barcodeState === 0)
  }
  const isDoor2Doored = codes[0] && codes[0].workState == 40 //已确认上户
  const product_state = order.isAnyTimeRefund === 1 // 随时退
  return (
    (order.refundState === 10 || order.refundState === 40) &&
    product_state &&
    !isDoor2Doored &&
    canUseCodes.length === codes.length &&
    order.payPrice !== 0 // 0元不退
  )
}
